<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="less">
	.atmi1{
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
	}

  .seach_input{
    width: 100%;
    height: 75px;
    position: relative;
    background: #ffffff;
    .seachImg{
      width: 40px;
      position: absolute;
      top: 8px;
      left: 40px;
    }
    .input{
      width: 635px;
      height: 50px;
      margin: 0 auto;
      display: block;
      font-size: 26px;
      padding-left: 55px;
      border-radius: 10px;
      border: 2px solid #969799;
    }
    .sbutton{
      position: absolute;
      top:5px;
      right:28px;
      height: 50px;
    }
  }

  .tableBox{
    margin: 0 auto;
    width: 720px;
    margin-top: 10px;
    .tableh5{
      img{
        width: 15px;
        height: 15px;
        vertical-align: middle;
      }
      span{
        font-size: 14px;
        vertical-align: middle;
        color: #1890ff;
      }
    }
		.biaoti{
		  font-size: 26px;
		  padding-left: 30px;
		  height: 60px;
		  line-height: 60px;
		  position: relative;
		  border: 2px solid #dadada;
		  border-bottom: 0;
			font-weight: 600;
		  .addImg{
		    width: 50px;
		    position: absolute;
		    top: 50%;
		    transform: translateY(-50%);
		    right: 20px;
		  }
		}
    .tables{
      width: 100%;
      border-collapse: collapse;
      border: 2px solid #dadada;
      td{
        font-size: 24px;
        height: 60px;
        line-height: 60px;
        font-weight: 400;
        text-align: center;
      }
      th{
        font-size: 24px;
        height: 60px;
				line-height: 36px;
        font-weight: 400;
        text-align: center;
        // padding-left: 10px;
				min-width: 200px;
        .del{
          color: #438cff;
        }
				.select{
					border: 0;
					width: 90%;
					height: 100%;
					outline: none;
					font-size: 24px;
				}
      }
    }
  }

  .inputBox{
    input{
      border-radius: 3px;
      padding-left: 10px;
    }
   }
   .van-button--mini{
     padding: 0 12px;
   }
</style>



// WEBPACK FOOTER //
// src/App.vue